import api from "./api";

export default class ExtratoApi {
  static getExtractPerClient = async (
    page: Number,
    RecordsPerPage: Number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  // Rota nova do extrato: uma consulta so, ja com a ponte do split resolvida
  // no servidor. Ao contrario da v1, respeita Page/RecordsPerPage - entao a
  // paginacao da tela passa a valer de verdade.
  static getExtractPerClientV2 = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    page?: number,
    recordsPerPage?: number
  ) => {
    const paginacao =
      page && recordsPerPage
        ? `&Page=${page}&RecordsPerPage=${recordsPerPage}`
        : "";
    const response = await api.get(
      `/Extrato/v2?dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}${paginacao}`
    );
    return response;
  };

  // Linhas do EXTRATO SPLIT (tabela ExtratoSplit). O extrato normal mostra, por
  // linha, quanto daquela venda foi splitado; o razao em si — inclusive o
  // repasse que zera o saldo splitado — so existe deste lado.
  // A API ignora o idCliente enviado para papel de cliente e usa o do token.
  static getSplitPerClientV2 = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    page?: number,
    recordsPerPage?: number
  ) => {
    const paginacao =
      page && recordsPerPage
        ? `&Page=${page}&RecordsPerPage=${recordsPerPage}`
        : "";
    const response = await api.get(
      `/ExtratoSplit/v2?dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}${paginacao}`
    );
    return response;
  };

  // Saldo do razao split (anterior + periodo). So devolve linha para cliente com
  // alguma movimentacao na ExtratoSplit — e o que diz se ele opera com split,
  // independente de ter lancamento no periodo consultado.
  static getSplitSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/ExtratoSplit/saldo?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static getExtractList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    filtroSaldo: string
  ) => {
    const response = await api.get(
      `/Extrato/listagem?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}&filtroSaldo=${filtroSaldo}`
    );
    return response;
  };

  static getExtractFutureReleasesList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&lancamentosFuturos=${true}&idCliente=${idCliente}`
    );
    return response;
  };

  static getSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static getSaldoVendas = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo/vendas/${idCliente}?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response;
  };

  static postLancamento = async (obj: any) => {
    const response = await api.post(`/Extrato`, obj);
    return response.data;
  };

  static getFutureSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo/vendas-futuras?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static exportFile = async (
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string,
    ModoPgto: any,
    idStatus: any
  ) => {
    const response = await api.get(
      `/Transacao/download?dataInicio=${dataInicio}&dataFim=${dataFim}&Search=${search}&idCliente=${id}&ModoPgto=${ModoPgto}&idStatus=${idStatus}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static exportExtract = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    id: any,
    filtroSaldo: string,
    future: boolean
  ) => {
    const response = await api.get(
      `/Extrato/download/detalhado/cliente?Page=${page}&RecordsPerPage=${RecordsPerPage}&filtroSaldo=${filtroSaldo}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${id}&futuro=${future}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static getSaldoBandeira = async (dataInicio: any, dataFim: any, id: any) => {
    const response = await api.get(
      `/Saldo/bandeira/${id}?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response.data;
  };
}
